<template>
  <div class="video-review-questions">
    <MicroAnimation
      v-if="videoDetail.video_url"
      :from="from"
      @submitEnd="submitEnd"
      :videoSrc="videoDetail.video_url"
      :videoPoster="videoDetail.video_coverimg"
    ></MicroAnimation>
    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>
<script>
import MicroAnimation from "@/components/StudyCenter/Review/MicroAnimation"; // 微动画
import PopTips from "@/components/popTips";
import ClassvideoHttp from "../classroom";
export default {
  name: "video-review-questions",
  data() {
    return {
      from: "",
      isTaskCenter: false,
      videoDetail: {
        video_url: "",
        video_coverimg: ""
      },
      dialogVisable: false,
      popTipsCont: {
        title: this.$t('blendType.reword'),
        context: `<span class="gold"></span> +4`,
        btns: [
          {
            text:  this.$t('Common.confirm'),
            event: "handConfirm"
          }
        ]
      }
    };
  },
  components: {
    MicroAnimation,
    PopTips
  },
  created() {
    this.$store.dispatch("setLoadingStatus", true);
    this.id = this.$route.query.id;
    this.from = this.$route.query.from;
    this.isTaskCenter = this.$route.query.taskitem_id && this.$route.query.item_id
    this.student_id = this.$store.state.currentChild.student_id;
    this.classcode_branch = this.$store.state.currentChild.classcode_branch;
    this.getHourMediaOne();
  },
  methods: {
    submitEnd(v) {
      console.log(v);
      if (v == 'quket' && !this.isTaskCenter) {
        this.AddKCTVGold({})
      } else if (v == 'quket' && this.isTaskCenter) {
        this.SubmitTask()
      }
    },
    // 完成 题目 提交成功
    SubmitTask() {
      ClassvideoHttp.SubmitTask({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        taskitem_id: this.$route.query.taskitem_id //   任务id 仅在任务完成部分的复习模块中需要传
      }).then(res => {
        const { error, result } = res.data;
        if (error == 0) {
          const { list } = result;
          if (list.playclass == 0) {
            this.popTipsCont.context = `<span class="gold"></span> +${result.list.playprice}`;
            let childInfo = this.$store.state.currentChild;
            childInfo.student_goldprice = list.totalPrice;
            this.$Tool.setStorage("currentStuInfo", childInfo);
            this.$store.dispatch("setCurrentChild", childInfo);
          } else {
            this.popTipsCont.context = `<span class="zs-icon"></span> +${result.list.playprice}`;
            let childInfo = this.$store.state.currentChild;
            childInfo.student_diamondprice = list.totalPrice;
            this.$Tool.setStorage("currentStuInfo", childInfo);
            this.$store.dispatch("setCurrentChild", childInfo);
          }
          this.dialogVisable = true;
        }
      });
    },
    AddKCTVGold () {
      ClassvideoHttp.AddKCTVGold({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        media_name: this.chooseItem.media_name,
        gold	: this.chooseItem.media_gold
      }).then(res => {
        const { error, result } = res.data
        if (error == 0) {
          this.popTipsCont.context = `<span class="gold"></span> +${result.list.playprice}`
          this.dialogVisable = true
        }
      }) 
    },
    bakToPrev() {
      // this.$router.push({ path: "/StudyCenter" });
      console.log("bakToPrev");
    },
    submitOk() {
      this.dialogVisable = true;
    },
    handleCloseTip() {
      this.dialogVisable = false;
    },
    handConfirm() {
      console.log("ok");
      this.$router.go(-1)
    },
    getHourMediaOne () {
      ClassvideoHttp.getHourMediaOne({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        media_id: this.id
      }).then(res => {
        const { error, result } = res.data;
        if (error == 0) {
          this.chooseItem = result.list
          this.videoDetail.video_url = result.list.media_url;
          this.videoDetail.video_coverimg = result.list.media_coverimg;
        }
        this.$store.dispatch("setLoadingStatus", false);
      })
    },
  }
};
</script>
<style lang="less">
.video-review-questions {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .empty-icon {
      width: 119px;
      height: 156px;
      background: url(../../../../assets/images/studyCenter/empty-icon.png)
        center center no-repeat;
      background-size: 100% 100%;
    }
    p {
      margin-top: 15px;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
    }
  }
}
</style>
<style lang="less">
.prop-content {
  display: flex;
  align-items: center;
  justify-content: center;
  .gold,
  .zs-icon {
    width: 26px;
    height: 26px;
    margin-right: 10px;
    border-radius: 50%;
  }
  .gold {
    background: url(../../../../assets/images/studyCenter/questions/gold-icon.png)
      center center no-repeat;
    background-size: cover;
  }
  .zs-icon {
    background: url(../../../../assets/images/myCenter/diamond.png) center
      center no-repeat;
    background-size: cover;
  }
}
</style>